import { useEffect, useRef } from 'react'

import PageFrame from 'components/PageFrame/PageFrame'

const DashboardView = ({}) => {
  const soundContainer = useRef(null)

  return (
    <PageFrame>
      <div className="dashboard-view"></div>
    </PageFrame>
  )
}

export default DashboardView
